// config/databaseGuard.ts - Trava anti-produção do front da Dinâmica (D57).
// Espelho da regra de winieduca/packages/shared/src/databases.ts; o teste do backend
// (backend/test/database.test.ts) confere que as listas continuam iguais.

/** Bancos de produção do projeto (auditoria 05, E1; `platform` nasce antes do corte, D50). */
export const PRODUCTION_DATABASE_IDS: readonly string[] = [
  '(default)',
  'platform',
  'app-dinamica-pedagogica',
  'app-reordem',
  'app-bolsa-ciencia',
  'app-quebra-cabeca',
  'app-criador-personalidades',
];

/** Clones de 26/09/2026: os únicos bancos aceitos em desenvolvimento (D57). */
export const DEVELOPMENT_DATABASE_IDS: readonly string[] = [
  'default-clone',
  'app-dinamica-pedagogica-clone',
  'app-bolsa-ciencia-clone',
];

/**
 * Devolve o ID do banco da Dinâmica. No servidor de desenvolvimento do Vite só aceita clones;
 * em build de produção só aceita banco de produção. Lança erro com o motivo em qualquer outro caso.
 */
export function resolveDinamicaDatabaseId(isDevServer: boolean, raw: string | undefined): string {
  const id = raw?.trim();
  if (!id) throw new Error('Recusado: VITE_DINAMICA_DATABASE_ID não está configurado.');
  if (isDevServer && !DEVELOPMENT_DATABASE_IDS.includes(id)) {
    const motivo = PRODUCTION_DATABASE_IDS.includes(id) ? 'é banco de produção' : 'não é um clone conhecido';
    throw new Error(
      `Recusado: VITE_DINAMICA_DATABASE_ID="${id}" ${motivo}. Em desenvolvimento, use um clone: ${DEVELOPMENT_DATABASE_IDS.join(', ')}.`
    );
  }
  if (!isDevServer && !PRODUCTION_DATABASE_IDS.includes(id)) {
    throw new Error(`Recusado: VITE_DINAMICA_DATABASE_ID="${id}" não é um banco de produção conhecido.`);
  }
  return id;
}

/**
 * Banco da plataforma (perfil do professor: nome e letra salva, D84). Em desenvolvimento, só o clone
 * `default-clone`; no build de produção, `platform` (D50), que é também o padrão se a variável faltar.
 */
export function resolvePlatformDatabaseId(isDevServer: boolean, raw: string | undefined): string {
  const id = raw?.trim();
  if (isDevServer) {
    if (id !== 'default-clone') {
      throw new Error(`Recusado: VITE_PLATFORM_DATABASE_ID="${id ?? ''}". Em desenvolvimento, use default-clone.`);
    }
    return id;
  }
  if (!id) return 'platform';
  if (id !== 'platform') throw new Error(`Recusado: VITE_PLATFORM_DATABASE_ID="${id}" não é o banco da plataforma.`);
  return id;
}
